import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { damage } from "../Redux/Features/damageSlice";
import { useNavigate } from "react-router-dom";
import CarCrashTwoToneIcon from "@mui/icons-material/CarCrashTwoTone";
import DamageSelection from '../Pages/DamageSelection';
import { deleteCarData } from "../services/indexDBService";
import { getDynamicToken } from '../utils/authUtils';
import {
    Grid,
    Card,
    CardContent,
    Button,
    FormControl,
    FormGroup,
    TextField,
    Typography,
    Radio,
} from "@mui/material";
import { useTelemetry } from "../telemetry/TelemetryProvider";

const SubmitForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        isParked: false,
        inWorkshop: false,
        licenseNumber: "",
        accidentDescription: "",
        charCountWarning: false,
        isFormValid: false,
        licenseNumberRequired: true,
    });

    const breakin = useSelector((state) => state.breakin);
    const damageData = useSelector((state) => state.damage.damageData);
    const sessionId = useSelector((state) => state.car.sessionId);
    const isDamageRecorded = useSelector(
        (state) => state.damage.isDamageRecorded
    );
    const reduxDamage = useSelector((state) => state.damage.damageData);

    const [charCountWarn, setCharCountWarn] = useState(false);
    let fetchedDamageData = null;

    const { track, tSessionId } = useTelemetry();

    useEffect(() => {
        const checkLocalStorage = () => {
            const localDamageData = localStorage.getItem("lc_damage");
            if (!!localDamageData) {
                dispatch(damage.setDamageRecorded(true));
                dispatch(damage.setDamageData(localDamageData));
            }
        };
        const interval = setInterval(checkLocalStorage, 3000);
        return () => clearInterval(interval);
    }, [damageData]);

    useEffect(() => {
        const isLicenseNumberRequired = formData.isParked === false;
        const isFormValid =
            isDamageRecorded &&
            charCountWarn &&
            formData.accidentDescription !== "" &&
            (!isLicenseNumberRequired || formData.licenseNumber.trim().length > 0);

        setFormData((prevFormData) => ({
            ...prevFormData,
            isFormValid: isFormValid,
            licenseNumberRequired: isLicenseNumberRequired,
        }));
    }, [
        formData.isParked,
        formData.inWorkshop,
        formData.licenseNumber,
        formData.accidentDescription,
        isDamageRecorded,
    ]);

    useEffect(() => {
        fetchedDamageData = fetchDamageFromDB();

        fetchedDamageData
            .then((response) => {
                if (response !== null && Object.keys(response).length > 0) {
                    dispatch(damage.setDamageRecorded(true));
                    dispatch(damage.setDamageData(response));
                } else {
                }
            })
            .catch((error) => {
                console.error("An error occurred while fetching damage data:", error);
            });
    }, []);


    async function fetchDamageFromDB() {
        try {
            const dynamicToken = await getDynamicToken();

            const encClaimNo = encodeData(breakin.claim_number);
            let data = JSON.stringify({
                ClaimNo: encClaimNo,
            });

            const response = await axios.post(
                `${import.meta.env.VITE_API_URL}/fetchPOIDamage`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${dynamicToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (
                response.data?.GetDataForPOICustomerResult &&
                response.data.GetDataForPOICustomerResult.Message &&
                response.data.GetDataForPOICustomerResult.Message.Error
            ) {
                return null;
            }

            return response.data;
        } catch (error) {
            console.error(error);
            return null;
        }
    }

    // Button style
    const submitButtonStyle = {
        outline: "none",
        display: "block",
        padding: "12.5px",
        width: "100%",
        margin: "20px auto",
        backgroundColor: formData.isFormValid ? "#EC6466" : "grey",
        color: "white",
        border: "none",
        borderRadius: "8px",
        fontSize: "20px",
        cursor: "pointer",
    };

    const encodeData = (data) => {
        return data;
    };

    const handleDamageSelectionClick = () => {
        window.open("/damage-selection", "_blank");
    };

    const handleInputChange = (e) => {
        const { name, value, checked } = e.target;
        const charCountWarning =
            name === "accidentDescription" && value.length > 200;
        setCharCountWarn(!charCountWarning ? true : false);
        setFormData((prevValues) => ({
            ...prevValues,
            [name]: e.target.type === "checkbox" ? checked : value,
            charCountWarning: charCountWarning,
        }));
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        track('SUBMIT_CLICKED');

        if (sessionId || breakin.claim_number) {
            try {
                const key = sessionId || breakin.claim_number;
                await deleteCarData(key);
                console.log("IndexedDB data deleted successfully");
            } catch (error) {
                console.warn("Error deleting data from IndexedDB:", error);
            }
        }

        try {
            const dynamicToken = await getDynamicToken();

            const data = {
                AccidentDate: breakin.loss_date,
                AccidentTime: breakin.loss_time,
                DescriptionOfAccident: formData.accidentDescription,
                DrivingLicenceNo: formData.licenseNumber,
                InsuredName: breakin.insured_name,
                MasterClaimNumber: breakin.claim_number,
                PointOfImpact: fetchedDamageData ? fetchedDamageData : (typeof damageData != "object" ? JSON.parse(damageData) : damageData),
                PolicyNo: breakin.pol_num,
                WorkshopCode: "",
                WorkshopName: "",
                IsVehicleParked: formData.isParked,
                IsVehicleAtWorkshop: formData.inWorkshop,
            };

            const encryptedData = encodeData(JSON.stringify(data));

            const response = await axios.post(
                `${import.meta.env.VITE_API_URL}/saveClaimForm`,
                { EncJSON: encryptedData },
                {
                    headers: {
                        Authorization: `Bearer ${dynamicToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            navigate("/thank");
        } catch (error) {
            console.error(error);
        }
    };
    return (
        <>
            <Card
                sx={{
                    margin: "5px",
                    boxShadow: "0px 2px 6px rgba(0,0,0.1)",
                    borderRadius: "7px",
                    mt: "15px",
                }}
            >
                <CardContent>
                    <Typography
                        variant="h5"
                        gutterBottom
                        sx={{ fontSize: "20px", fontWeight: "bold" }}
                    >
                        Digital Claim Form
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Please provide with the following information to start your claim
                        journey.
                    </Typography>
                    <br />
                    <FormControl component="fieldset">
                        <FormGroup>
                            <Grid container spacing={2}>
                                {/* Damage Selection */}
                                <Grid
                                    item
                                    xs={12}
                                    container
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Grid item xs={12} md={6}>
                                        {/* <Typography variant="body1" color="textPrimary">
                            Please select the damages to your vehicle on the image
                        </Typography> */}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        container
                                        justifyContent="flex-end"
                                        alignItems="center"
                                    >
                                        {/* <Button
                            variant="contained"
                            startIcon={
                            <CarCrashTwoToneIcon style={{ marginLeft: "10px" }} />
                            }
                            sx={{
                            borderRadius: "10px",
                            bgcolor: "#ec6466",
                            color: "white",
                            width: { xs: "100%", md: "auto" },
                            }}
                            onClick={handleDamageSelectionClick}
                        >
                            Tap here to select your Damage.
                        </Button> */}
                                    </Grid>
                                </Grid>

                                {/* Accident Description */}
                                <Grid item xs={12}>
                                    <Typography variant="body1" color="textPrimary">
                                        Please describe the accident in detail:
                                    </Typography>
                                    <TextField
                                        label={
                                            formData.accidentDescription === ""
                                                ? ""
                                                : `${Math.abs(
                                                    Math.max(
                                                        -200,
                                                        200 - formData.accidentDescription.length
                                                    )
                                                )} ${formData.accidentDescription.length > 200
                                                    ? "characters extra"
                                                    : "characters remaining"
                                                }`
                                        }
                                        multiline
                                        error={
                                            formData.charCountWarning ||
                                            formData.accidentDescription === ""
                                        }
                                        helperText={
                                            formData.charCountWarning
                                                ? "Maximum character limit exceeded."
                                                : formData.accidentDescription === ""
                                                    ? "This field is required"
                                                    : "200 characters max."
                                        }
                                        rows={4}
                                        fullWidth
                                        margin="normal"
                                        name="accidentDescription"
                                        value={formData.accidentDescription}
                                        onChange={handleInputChange}
                                        placeholder="In English - max 200 characters."
                                    />
                                </Grid>

                                {/* Radio Buttons Grid */}
                                <Grid item xs={12} container alignItems="center">
                                    {/* Text */}
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="body1" color="textPrimary">
                                            Was your vehicle parked at the time of accident?
                                        </Typography>
                                    </Grid>
                                    {/* Yes */}
                                    <Grid item container alignItems="center" xs={6} md={2}>
                                        <Radio
                                            color="secondary"
                                            checked={formData.isParked}
                                            onChange={() =>
                                                handleInputChange({
                                                    target: { name: "isParked", value: true },
                                                })
                                            }
                                        />
                                        <Typography variant="body2" color="textPrimary">
                                            Yes
                                        </Typography>
                                    </Grid>
                                    {/* No */}
                                    <Grid item container alignItems="center" xs={6} md={2}>
                                        <Radio
                                            color="secondary"
                                            checked={!formData.isParked}
                                            onChange={() =>
                                                handleInputChange({
                                                    target: { name: "isParked", value: false },
                                                })
                                            }
                                        />
                                        <Typography variant="body2" color="textPrimary">
                                            No
                                        </Typography>
                                    </Grid>
                                </Grid>

                                {/* Driving License Number */}
                                <Grid item xs={12}>
                                    <Typography variant="body1" color="textPrimary">
                                        Driving Licence No.
                                    </Typography>
                                    <TextField
                                        // label={formData.licenseNumberRequired ? 'Driving License Number *' : ''}
                                        fullWidth
                                        margin="normal"
                                        error={
                                            formData.licenseNumberRequired &&
                                            formData.licenseNumber === ""
                                        }
                                        helperText={
                                            formData.licenseNumberRequired &&
                                                formData.licenseNumber === ""
                                                ? "This field is required."
                                                : ""
                                        }
                                        name="licenseNumber"
                                        value={formData.licenseNumber}
                                        onChange={handleInputChange}
                                        required={formData.licenseNumberRequired}
                                        placeholder="Please include dash, slash as per your original document."
                                    />
                                </Grid>
                            </Grid>
                        </FormGroup>
                        <Typography variant="body1" fontWeight="bold">
                            Workshop Name:{" "}
                            <span style={{ color: "#ec6466", fontStyle: "italic" }}>
                                {breakin.workshop_name
                                    ? breakin.workshop_name
                                    : "Not in workshop"}
                            </span>
                        </Typography>
                    </FormControl>
                </CardContent>
                {/* <CardActions style={{ justifyContent: 'center' }}>
                    <Button variant="contained" sx={{ borderRadius: '20px', bgcolor: '#ec6466', color: 'white' }} onClick={handleDamageSelectionClick}>
                        Damage Selection
                    </Button>
                </CardActions> */}
            </Card>
            <Card
                sx={{
                    margin: "5px",
                    boxShadow: "0px 2px 6px rgba(0,0,0.1)",
                    borderRadius: "7px",
                    mt: "15px",
                }}>
                <CardContent>

                    <Typography
                        variant="h5"
                        gutterBottom
                        sx={{ fontSize: "20px", fontWeight: "bold" }}
                    >
                        Damage Selection Area
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Please save your damage after selecting.
                    </Typography>
                    <br />
                    <DamageSelection />
                </CardContent>
            </Card>
            <Button
                //type="submit"
                style={submitButtonStyle}
                disabled={!formData.isFormValid}
                onClick={handleSubmit}
            >
                Submit
            </Button>
        </>
    );
};

export default SubmitForm;
